<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row mb-4">
        <div class="d-flex align-items-center">
          <img :src="sidebarBackgroundImage" alt="" style="width: 40px; margin-right: 12px;">
          <h2 class="page-title">
            {{ product.extra_name }} <span class="page-title-sub">({{ $t($route.name) }})</span>
          </h2>
        </div>
        <div class="header-actions">
          <router-link v-if="$route.name=='Товар модал update' || $route.name=='Товар модал create'" :to="{ path: '/directory/product/index' }">
            <button type="button" class="btn-cancel">
              {{ $t("Chiqish") }} <sup>esc</sup>
            </button>
          </router-link>
          <router-link v-else :to="{ path: '/malumot/product/index' }">
            <button type="button" class="btn-cancel">
              {{ $t("Chiqish") }} <sup>esc</sup>
            </button>
          </router-link>
          <button type="button" class="btn-save" @click="Savedokument()">
            <b-icon icon="check-all" class="mr-1"></b-icon>
            {{ $t("Saqlash") }} <sup>ctrl+enter</sup>
          </button>
        </div>
      </div>

      <!-- ASOSIY FORMA -->
      <div class="modern-card">

        <!-- Yuqori qism: Kod, Papka, Umumiy nomi, Nomi -->
        <div class="row">
          <div class="col-md-2">
            <div class="form-unit">
              <label>Kod</label>
              <input class="form-input" ref="focused" v-model="product.number" type="text" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-unit">
              <label>{{ $t("Umumiy nomi") }}</label>
              <input type="text" readonly v-model="product.extra_name" class="form-input readonly">
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-unit">
              <label>{{ $t("Nomi") }}</label>
              <input class="form-input" @input="Extra()" v-model="product.name" type="text" />
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-unit">
              <label v-if="product.is_folder==false">{{ $t("Pachka") }}</label>
              <label v-else>{{ $t("Ko'rsatish") }}</label>
              <span v-if="product.is_folder==false">
                <input class="form-input" v-model="product.pack_count" type="number" />
              </span>
              <span v-else>
                <input type="checkbox" class="modern-checkbox" v-model="product.see">
              </span>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-unit">
              <label v-if="product.is_folder==false">{{ $t("Min. kol.") }}</label>
              <label v-else>&nbsp;</label>
              <span v-if="product.is_folder==false">
                <input type="number" class="form-input" v-model="product.minimum_amount">
              </span>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-unit checkbox-unit">
              <label>Papka</label>
              <input type="checkbox" v-model="product.is_folder" class="modern-checkbox" />
            </div>
          </div>
        </div>

        <div class="section-divider-h"></div>

        <!-- O'rta qism: Select va Shtrix kodlar -->
        <div class="row">
          <div class="col-md-4">
            <div class="section-header">
              <b-icon icon="tag"></b-icon>
              <span>{{ $t("Xususiyatlar") }}</span>
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Eд.изм.") }}</label>
                  <v-select :clearable="true" class="modern-vselect" :options="unitlist" v-model="product.unit_id"
                    :reduce="name => name.id" label="name">
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button type="button" class="modallist" v-b-modal.modal-unitlist>
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button type="button" class="pluss" @click="unit.name = search" v-b-modal.modal-unit>+</button>
                        <b>insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>Brend</label>
                  <v-select :clearable="true" class="modern-vselect" :options="brandlist" @input="Brandchange"
                    v-model="product.brand_id" :reduce="name => name.id" label="name">
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button type="button" class="modallist" v-b-modal.modal-brandlist>
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button type="button" @click="brand.name = search" v-b-modal.modal-brand class="pluss">+</button>
                        <b>insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>Model</label>
                  <v-select :clearable="true" multiple class="modern-vselect" :options="modellist" @input="Modelchange"
                    v-model="product.model_ids" :reduce="name => name.id" label="name">
                    <template #selected-option="option">
                      {{ modelOptionName(option) }}
                    </template>
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button type="button" class="modallist" v-b-modal.modal-modellist>
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button type="button" @click="model.name = search" v-b-modal.modal-model class="pluss">+</button>
                        <b>insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Davlat") }}</label>
                  <v-select :clearable="true" class="modern-vselect" :options="countrylist" @input="Countrychange"
                    v-model="product.country_id" :reduce="name => name.id" label="name">
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button type="button" class="modallist" v-b-modal.modal-countrylist>
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button type="button" class="pluss" @click="country.name = search" v-b-modal.modal-country>+</button>
                        <b>insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Guruh") }}</label>
                  <v-select :clearable="true" class="modern-vselect" :options="folder" v-model="product.parent_id"
                    :reduce="extra_name => extra_name.id" label="extra_name">
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        {{ $t("бўйича маьлумот йўқ") }}
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Rang") }}</label>
                  <v-select :clearable="true" class="modern-vselect" :options="colourlist" @input="Colourchange"
                    v-model="product.colour_id" :reduce="name => name.id" label="name">
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button type="button" class="modallist" v-b-modal.modal-colourlist>
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button type="button" @click="colour.name = search" v-b-modal.modal-colour class="pluss">+</button>
                        <b>insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="section-header">
              <b-icon icon="fonts"></b-icon>
              <span>{{ $t("Qo'shimcha nomlar") }}</span>
            </div>

            <div class="form-unit">
              <label>{{ $t("Dop. nomi") }} 1</label>
              <v-select :clearable="true" class="modern-vselect" :options="extraunitlist"
                v-model="product.extra_unit_id1" :reduce="name => name.id" @input="Extranamechange" label="name">
                <template #search="{attributes, events}">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button @click="unittype=1" type="button" class="modallist" v-b-modal.modal-extraunitlist>
                    <b-icon icon="three-dots"></b-icon>
                  </button>
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <em><b>{{ search }}</b></em>
                    {{ $t("бўйича маьлумот йўқ") }}
                    <button type="button" class="pluss" @click="extraunit.name = search;unittype=1;" v-b-modal.modal-extraunit>+</button>
                    <b>insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
            </div>

            <div class="form-unit">
              <label>{{ $t("Dop. nomi") }} 2</label>
              <v-select :clearable="true" class="modern-vselect" :options="extraunitlist"
                v-model="product.extra_unit_id2" :reduce="name => name.id" @input="Extranamechange2" label="name">
                <template #search="{attributes, events}">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button @click="unittype=2" type="button" class="modallist" v-b-modal.modal-extraunitlist>
                    <b-icon icon="three-dots"></b-icon>
                  </button>
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <em><b>{{ search }}</b></em>
                    {{ $t("бўйича маьлумот йўқ") }}
                    <button type="button" class="pluss" @click="extraunit.name = search;unittype=2;" v-b-modal.modal-extraunit>+</button>
                    <b>insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
            </div>

            <div class="form-unit">
              <label>{{ $t("Dop. nomi") }} 3</label>
              <input type="text" class="form-input" v-model="product.quality" @input="Extra()" />
            </div>

            <div class="form-unit">
              <label>{{ $t("Artikul") }}</label>
              <input type="text" class="form-input" v-model="product.artikul" placeholder="Masalan: 26301520 yoki T152905010" />
            </div>

            <!-- Shtrix kodlar -->
            <div class="shtrix-card">
              <div class="shtrix-header">
                <span>Shtrix kod</span>
                <div>
                  <button type="button" class="shtrix-btn" @click="Createshtrix()">{{ $t("Yangi") }}</button>
                  <button type="button" class="shtrix-btn" @click="Addshtrix(update)">+</button>
                </div>
              </div>
              <div class="shtrix-body">
                <div v-for="(item, index) in product.shtrix_table" :key="index" class="shtrix-row">
                  <span class="shtrix-num">{{ index + 1 }}</span>
                  <input type="text" class="form-input" v-model="item.shtrix_kod" @change="Addshtrix('update')" />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <!-- Foto -->
            <div class="section-header">
              <b-icon icon="image"></b-icon>
              <span>Foto</span>
            </div>
            <div class="photo-card">
              <div class="photo-actions">
                <input type="file" id="files" ref="files" v-on:change="handleFilesUpload()" class="photo-input" />
                <button v-if="product.picture_name!='' && product.picture_name!='undefined'" type="button" class="photo-remove" @click="product.picture_name=''">
                  <b-icon style="color:red;" icon="x-lg"></b-icon>
                </button>
              </div>
              <div class="photo-preview">
                <img v-if="files!=''" v-bind:src="product.picture_name" />
                <img v-else-if="product.picture_name!='' && product.picture_name!='undefined'" v-bind:src="axios.defaults.baseURL+'/api/v1/uploads/'+product.picture_name" />
                <div v-else class="photo-placeholder">
                  <b-icon icon="image" font-scale="3"></b-icon>
                  <span>Rasm tanlang</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-divider-h"></div>

        <!-- Pastki qism: Narxlar -->
        <div class="row">
          <div class="col-md-4">
            <div class="section-header">
              <b-icon icon="currency-exchange"></b-icon>
              <span>{{ $t("Narxlar") }}</span>
            </div>
            <div class="price-card" v-if="pricelist.length>0">
              <div class="row">
                <div class="col-6">
                  <div class="form-unit">
                    <label>{{ $t("Ulg.") }} {{ $t("narx") }}</label>
                    <input type="number" v-model="pricelist[0].optom_price" @change="Updateprice()" class="form-input" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-unit">
                    <label>{{ $t("Ulg.") }} {{ $t("narx") }} $</label>
                    <input type="number" v-model="pricelist[0].optom_dollar_price" @change="Updateprice()" class="form-input" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-unit">
                    <label>{{ $t("Chak.") }} {{ $t("narx") }}</label>
                    <input type="number" @change="Updateprice()" v-model="pricelist[0].chakana_price" class="form-input" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-unit">
                    <label>{{ $t("Chak.") }} {{ $t("narx") }} $</label>
                    <input type="number" @change="Updateprice()" v-model="pricelist[0].chakana_dollar_price" class="form-input" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-unit">
                    <label>Valyuta</label>
                    <input type="text" :disabled="true" class="form-input readonly"
                      :value="pricelist[0].price_type==1?'So\'m':'Dollar'">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-8" v-if="pricelist.length>0">
            <b-tabs content-class="mt-3">
              <!-- Partiya tab -->
              <b-tab title="Partiya" active>
                <div class="mini-table-wrapper">
                  <table class="mini-table">
                    <thead>
                      <tr>
                        <th>Partiya</th>
                        <th>{{ $t("Tip tsena") }}</th>
                        <th>{{ $t("Pos.") }} {{ $t("Narx") }}</th>
                        <th>{{ $t("Sebes.") }}</th>
                        <th>{{ $t("Ulg.") }} {{ $t("Narx") }}$</th>
                        <th>{{ $t("Chak.") }} {{ $t("Narx") }}$</th>
                        <th>{{ $t("Ulg.") }} {{ $t("Narx") }}</th>
                        <th>{{ $t("Chak.") }} {{ $t("Narx") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in serialist" :key="'s'+index">
                        <td>{{ SetDatetime(item.datetime) }}</td>
                        <td>
                          <span v-if="item.price_type==1">Naqd</span>
                          <span v-else-if="item.price_type==2">Plastik</span>
                          <span v-else>Dollar</span>
                        </td>
                        <td class="td-right">{{ item.delivery_price }}</td>
                        <td class="td-right">{{ item.prixod_price }}</td>
                        <td class="td-right">{{ item.optom_dollar_price }}</td>
                        <td class="td-right">{{ item.optom_price }}</td>
                        <td class="td-right">{{ item.chakana_dollar_price }}</td>
                        <td class="td-right">{{ item.chakana_price }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <!-- Sklad tab -->
              <b-tab title="Sklad">
                <div class="mini-table-wrapper">
                  <table class="mini-table">
                    <thead>
                      <tr>
                        <th>Sklad</th>
                        <th>{{ $t("Ulg.") }} {{ $t("Narx") }}$</th>
                        <th>{{ $t("Chak.") }} {{ $t("Narx") }}$</th>
                        <th>{{ $t("Ulg.") }} {{ $t("Narx") }}</th>
                        <th>{{ $t("Chak.") }} {{ $t("Narx") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in allprice" :key="'a'+index">
                        <td>{{ item.sklad_name }}</td>
                        {{ Setzero(item) }}
                        <td><input type="text" v-model="item.optom_dollar_price" class="table-input"></td>
                        <td><input type="text" v-model="item.chakana_dollar_price" class="table-input"></td>
                        <td><input type="text" v-model="item.optom_price" class="table-input"></td>
                        <td><input type="text" v-model="item.chakana_price" class="table-input"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  export default {
    name: "product-modal-form",
    data() {
      return {
        increment:0,
        allprice:[],
        sidebarBackgroundImage: require("@/assets/img/logomini.png"),
        unittype: 1,
        extraunitlist: [],
        extraunit: { name: "" },
        files: "",
        pricelist: [
          {body_price:0,chakana_dollar_price:0,chakana_price:0,datetime:0,delivery_price:0,doc_id:0,doc_type:"",id:0,optom_dollar_price:0,optom_price:0,price_type:1,product_id:0,series_id:0,sklad_id:0}
        ],
        serialist: [],
        filter: "",
        unitlist: [],
        countrylist: [],
        productlist: [],
        unit: { name: "" },
        model: { name: "" },
        modellist: [],
        brand: { name: "" },
        brandlist: [],
        colour: { name: "" },
        colourlist: [],
        pricesettings:[],
        folder: [],
        country: { name: "" }
      };
    },
    props: ["product"],
    watch: {
    allprice: {
      deep: true,
      handler(val, oldVal) {
        this.increment+=1;
      }
    },
    // Create rejimida product.number kelganda shtrix kodni avtomatik to'ldirish
    'product.number': {
      immediate: true,
      handler(val) {
        if (this.$route.params.id != undefined) return;
        if (!val) return;
        if (!this.product || !Array.isArray(this.product.shtrix_table)) return;
        if (this.product.shtrix_table.length === 0) {
          this.product.shtrix_table.push({ shtrix_kod: "" });
        }
        if (!this.product.shtrix_table[0].shtrix_kod) {
          this.product.shtrix_table[0].shtrix_kod = 25 * 100000000000 + Number(val);
        }
      }
    }
  },
    computed: {
    },
    created() {
      let self = this;
      self.$root.$refs.product = self;
      self.$root.$on("unitone", function (getdata) {
        self.unit = getdata;
      });
      self.$root.$on("unitall", function (getdata) {
        self.unitlist = getdata;
      });
      self.$root.$on("unitselected", function (getdata) {
        self.product.unit_id = getdata;
      });
      self.$root.$on("extraunitone", function (getdata) {
        self.extraunit = getdata;
      });
      self.$root.$on("extraunitall", function (getdata) {
        self.extraunitlist = getdata;
      });
      self.$root.$on("extraunitselected", function (getdata) {
        if (getdata > 0) {
          if (self.unittype == 1) {
            self.product.extra_unit_id1 = getdata;
            setTimeout(() => {
              self.Extranamechange(self.product.extra_unit_id1);
            }, 100);
          } else {
            self.product.extra_unit_id2 = getdata;
            setTimeout(() => {
              self.Extranamechange2(self.product.extra_unit_id2);
            }, 100);
          }
        }
      });
      self.$root.$on("modelone", function (getdata) {
        self.model = getdata;
      });
      self.$root.$on("modelall", function (getdata) {
        self.modellist = getdata;
      });
      self.$root.$on("modelselected", function (getdata) {
        if (getdata > 0) {
          self.product.model_id = getdata;
          setTimeout(() => {
            self.Modelchange(self.product.model_id);
          }, 100);
        }
      });

      self.$root.$on("brandone", function (getdata) {
        self.brand = getdata;
      });
      self.$root.$on("brandall", function (getdata) {
        self.brandlist = getdata;
      });
      self.$root.$on("brandselected", function (getdata) {
        if (getdata > 0) {
          self.product.brand_id = getdata;
          setTimeout(() => {
            self.Brandchange(self.product.brand_id);
          }, 100);
        }
      });

      self.$root.$on("colourone", function (getdata) {
        self.colour = getdata;
      });
      self.$root.$on("colourall", function (getdata) {
        self.colourlist = getdata;
      });
      self.$root.$on("colourselected", function (getdata) {
        if (getdata > 0) {
          self.product.colour_id = getdata;
          setTimeout(() => {
            self.Colourchange(self.product.colour_id);
          }, 100);
        }
      });
      self.$root.$on("countryone", function (getdata) {
        self.country = getdata;
      });
      self.$root.$on("countryall", function (getdata) {
        self.countrylist = getdata;
      });
      self.$root.$on("countryselected", function (getdata) {
        if (getdata > 0) {
          self.product.country_id = getdata;
          setTimeout(() => {
            self.Countrychange(self.product.country_id);
          }, 100);
        }
      });
      if (self.$route.params.id==undefined) {
        axios.get("api/v1/product/auto-increment-id").then(function (response) {
            self.product.id=response.data.AUTO_INCREMENT;
          });
      }
    },
    mounted: function () {
      this.Focus();
      this.Extra();
      this.normalizeModelIds();
      this.Folder();
      this.Allprice();
      if (this.$route.params.id != undefined) {
        this.Pricelist();
        this.Serialist();
      }
      let self=this;
      axios.get("api/v1/sklads/id/1").then(function (response) {
          self.pricesettings = { common_price_type: response.data.common_price_type, chakana_price_type: response.data.chakana_price_type, optom_price_type: response.data.optom_price_type };
        });
    },
    methods: {
      Folder() {
        let self = this;
        axios.get("api/v1/product/folder-list").then(function (response) {
          self.folder = response.data;
        });
      },
      SetDatetime(date) {
        var d = new Date(date * 1000);
        var dt = d.getDate();
        var hour = d.getHours();
        var minut = d.getMinutes();
        var month = d.getMonth() + 1;
        if (month < 10) { month = "0" + month; }
        if (minut < 10) { minut = "0" + minut; }
        if (hour < 10) { hour = "0" + hour; }
        if (dt < 10) { dt = "0" + dt; }
        return d.getFullYear() + "-" + month + "-" + dt + 'T' + hour + ':' + minut;
      },
      Pricelist() {
        let self = this;
        axios({
          method: 'post',
          url: '/api/v1/product/price-list',
          data: { 'product_id': self.$route.params.id, sklad_id: parseInt(localStorage.getItem('sklad_id')) }
        }).then(function (response) {
          if(response.data.length>0){
          self.pricelist = response.data;
          }else{
            self.price_list.push({"body_price":0,"chakana_dollar_price":0,"chakana_price":1100,"datetime":0,"delivery_price":0,"doc_id":0,"doc_type":"Product","id":0,"optom_dollar_price":0,"optom_price":0,"price_type":1,"product_id":0,"series_id":0,"sklad_id":0,});
          }
        });
      },
      Allprice() {
        let self = this;
        var number;
        if(self.$route.params.id==undefined){
          number=self.product.number;
        }else{
          number=self.$route.params.id
        }
        axios({
          method: 'post',
          url: '/api/v1/product/last-price-all-sklad',
          data: { 'product_id': number}
        }).then(function (response) {
          self.allprice = response.data;
        });
      },
      Serialist() {
        let self = this;
        axios({
          method: 'post',
          url: '/api/v1/product/series-list',
          data: { 'product_id': self.$route.params.id, sklad_id: parseInt(localStorage.getItem('sklad_id')) }
        }).then(function (response) {
          self.serialist = response.data;
        });
      },
      Updateprice() {
        let self = this;
        if(self.pricelist[0].id>0){
        axios({
          method: 'post',
          url: '/api/v1/product/update-price/' + self.pricelist[0].id,
          data: { 'product_id': self.$route.params.id, sklad_id: parseInt(localStorage.getItem('sklad_id')), optom_price: self.pricelist[0].optom_price,optom_dollar_price: self.pricelist[0].optom_dollar_price, chakana_price: self.pricelist[0].chakana_price,chakana_dollar_price: self.pricelist[0].chakana_dollar_price }
        }).then(function (response) {
        });
      }
      },
      Createshtrix() {
        if (this.product.shtrix_table.length == 0) {
          this.Addshtrix();
        }
        var endcount;
        let self = this;
        if (self.$route.params.id != undefined) {
          endcount = this.product.number;
          var creating = 25 * 100000000000 + endcount;
          if (this.product.shtrix_table[0].shtrix_kod == "") {
            this.product.shtrix_table[0].shtrix_kod = creating;
          }
        } else {
            var creating = 25 * 100000000000 + self.product.number;
            if (self.product.shtrix_table[0].shtrix_kod == "") {
              self.product.shtrix_table[0].shtrix_kod = creating;
            }
        }
      },
      Focus() {
        this.$refs.focused.focus();
      },
      handleFilesUpload() {
        this.files = this.$refs.files.files;
        this.product.picture_name = URL.createObjectURL(
          this.$refs.files.files[0]
        );
      },
      Addshtrix(type) {
        this.product.shtrix_table.push({ shtrix_kod: "" });
        setTimeout(() => {
          var self = $(':focus'), form = self.parents(".row:eq(0)"), focusable, next, prev;
          focusable = form.find(".form-control");
          next = focusable.eq(-1);
          if (next.length) {
            next.focus();
          }
        }, 1000);
      },
      Savedokument() {
        let self = this;
        if (self.$route.params.id == undefined) {
          var methods = "post";
          var action = "api/v1/product";
        } else {
          var methods = "patch";
          var action = "api/v1/product/id/" + self.$route.params.id;
        }
        let formData = new FormData();
        let file = this.files[0];
        formData.append("picture_name", file);
        formData.append("see", this.product.see);
        formData.append("extra_name", this.product.extra_name);
        formData.append("name", this.product.name);
        formData.append("minimum_amount", this.product.minimum_amount);
        formData.append("pack_count", this.product.pack_count);

        if (this.product.unit_id == null) { this.product.unit_id = 0; }
        if (this.product.brand_id == null) { this.product.brand_id = 0; }
        if (this.product.colour_id == null) { this.product.colour_id = 0; }
        if (this.product.parent_id == null) { this.product.parent_id = 0; }
        if (this.product.country_id == null) { this.product.country_id = 0; }
        if (this.product.model_id == null) { this.product.model_id = 0; }
        this.normalizeModelIds();
        if (this.product.extra_unit_id1 == null) { this.product.extra_unit_id1 = 0; }
        if (this.product.extra_unit_id2 == null) { this.product.extra_unit_id2 = 0; }
        formData.append("number", this.product.number);
        formData.append("unit_id", this.product.unit_id);
        formData.append("colour_id", this.product.colour_id);
        formData.append("parent_id", this.product.parent_id);
        formData.append("is_folder", this.product.is_folder);
        formData.append("country_id", this.product.country_id);
        formData.append("model_id", this.product.model_id);
        formData.append("model_ids", this.product.model_ids.join(','));
        formData.append("brand_id", this.product.brand_id);
        formData.append("quality", this.product.quality);
        formData.append("artikul", this.product.artikul || "");
        formData.append("extra_unit_id1", this.product.extra_unit_id1);
        formData.append("extra_unit_id2", this.product.extra_unit_id2);
        if (this.product.shtrix_table.length > 0) {
          for (let i = 0; i < this.product.shtrix_table.length; i++) {
            formData.append(
              `shtrix_table[${i}][shtrix_kod]`,
              this.product.shtrix_table[i].shtrix_kod
            );
          }
        } else {
          formData.append(`shtrix_table[0][shtrix_kod]`, "");
        }
        axios({
          method: methods,
          url: action,
          data: formData
        }).then(function (response) {
          self.$store.state.saved = 1;
          localStorage.removeItem("product_name");
          if (self.$route.params.id == undefined) {
            var a = [];
            a.push({
              id: response.data.id,
              extra_name: response.data.extra_name,
              balance: 0,
              is_folder: response.data.is_folder,
              parent_id: response.data.parent_id,
              shtrix_table: [],
              price_register: []
            });
            var b = a.concat(self.$store.state.prostatka);
            self.$store.state.prostatka = b;
          } else {
            self.$store.state.prostatka = null;
          }
          self.$store.state.parent_id = self.product.parent_id;
          if(self.$route.params.id && self.pricelist[0].chakana_price>0 && !self.allprice[0].doc_id>0){
            self.allprice[0].chakana_price=self.pricelist[0].chakana_price;
            self.allprice[0].chakana_dollar_price=self.pricelist[0].chakana_dollar_price;
            self.allprice[0].optom_price=self.pricelist[0].optom_price;
            self.allprice[0].optom_dollar_price=self.pricelist[0].optom_dollar_price;
            self.increment=4;
          }
          if(self.increment<3){
            if(self.$route.path=='/directory/product/create' || self.$route.name=='Товар модал update'){
              self.$router.push({ name: "Товар модал" });
            }
            else{
              self.$router.push({ name: "Товар" });
            }
          }else{
            self.Setprice(response.data.id);
          }
        });
      },
       Setzero(item){
        if(item.body_price==null){ item.body_price=0; }
        if(item.delivery_price==null){ item.delivery_price=0; }
      },
      Setprice(id){
        let self=this;
        var pricetype=1;
        var list=[];
        self.allprice.forEach(function(key, value) {
            list.push({s_id:key.s_id,chakana_price:key.chakana_price,optom_price:key.optom_price,chakana_dollar_price:key.chakana_dollar_price,optom_dollar_price:key.optom_dollar_price,body_price:key.body_price,delivery_price:key.delivery_price});
        });
        if(self.pricesettings.common_price_type==2){
          pricetype=3;
        }
        var data={ 'product_id': id, doc_type:"product",doc_id:id,datetime:new Date().valueOf().toString().slice(0, 10),price_type:pricetype,price_list: list };
        axios({
          method: 'post',
          url: '/api/v1/product/new-price-all-sklad',
          data:data
        }).then(function (response) {
          if(self.$route.path=='/directory/product/create' || self.$route.name=='Товар модал update'){
              self.$router.push({ name: "Товар модал" });
            }
            else{
              self.$router.push({ name: "Товар" });
            }
        });
      },
      Extranamechange(val) {
        let self = this;
        if (val == null) { self.product.extra_unit1 = null; self.Extra(); }
        else {
          axios.get("api/v1/extra-unit/id/" + val).then(function (response) {
            self.product.extra_unit1 = response.data; self.Extra();
          });
        }
      },
      Extranamechange2(val) {
        let self = this;
        if (val == null) { self.product.extra_unit2 = null; self.Extra(); }
        else {
          axios.get("api/v1/extra-unit/id/" + val).then(function (response) {
            self.product.extra_unit2 = response.data; self.Extra();
          });
        }
      },
      Colourchange(val) {
        let self = this;
        if (val == null || val == 0) { self.product.colour = null; self.Extra(); }
        else {
          axios.get("api/v1/colour/id/" + val).then(function (response) {
            self.product.colour = response.data; self.Extra();
          });
        }
      },
      Brandchange(val) {
        let self = this;
        if (val == null || val == 0) { self.product.brand = null; self.Extra(); }
        else {
          axios.get("api/v1/brand/id/" + val).then(function (response) {
            self.product.brand = response.data; self.Extra();
          });
        }
      },
      Countrychange(val) {
        let self = this;
        if (val == null || val == 0) { self.product.country = null; self.Extra(); }
        else {
          axios.get("api/v1/country/id/" + val).then(function (response) {
            self.product.country = response.data; self.Extra();
          });
        }
      },
      Modelchange(val) {
        let self = this;
        const modelIds = Array.isArray(val) ? val : (val ? [val] : []);
        self.product.model_ids = modelIds;
        self.product.model_id = modelIds[0] || 0;
        if (modelIds.length === 0) { self.product.model = null; self.Extra(); }
        else {
          axios.get("api/v1/model/id/" + modelIds[0]).then(function (response) {
            self.product.model = response.data; self.Extra();
          });
        }
      },
      normalizeModelIds() {
        const ids = Array.isArray(this.product.model_ids)
          ? this.product.model_ids
          : String(this.product.model_ids || '').split(',').filter(Boolean);
        this.product.model_ids = ids.map(Number).filter(Boolean);
        if (this.product.model_ids.length === 0 && this.product.model_id) {
          this.product.model_ids = [Number(this.product.model_id)];
        }
        this.product.model_id = this.product.model_ids[0] || 0;
      },
      modelOptionName(option) {
        const values = Array.isArray(option)
          ? option
          : (option && typeof option === 'object'
            ? [option]
            : String(option || '').split(',').filter(Boolean));
        return values.map(value => {
          const namedModel = value && typeof value === 'object'
            ? this.modellist.find(item => item.name === value.name || item.name === value.label)
            : null;
          if (namedModel) return namedModel.name;
          const nestedValue = value && typeof value === 'object'
            ? (value.option || value.value || value.id || value.label || value.name)
            : value;
          const nestedValues = Array.isArray(nestedValue)
            ? nestedValue
            : String(nestedValue || '').split(',').filter(Boolean);
          return nestedValues.map(itemValue => {
            const id = itemValue && typeof itemValue === 'object'
              ? (itemValue.id || itemValue.value || itemValue.option)
              : itemValue;
            const model = this.modellist.find(item => Number(item.id) === Number(id));
            return model ? model.name : '';
          }).filter(Boolean).join(', ');
        }).join(', ');
      },
      Extra() {
        let self = this;
        self.product.extra_name = self.product.name;
        if (self.product.extra_unit1 != null) { self.product.extra_name = self.product.extra_name + " " + self.product.extra_unit1.name; }
        if (self.product.extra_unit2 != null) { self.product.extra_name = self.product.extra_name + " " + self.product.extra_unit2.name; }
        if (self.product.colour != null) { self.product.extra_name = self.product.extra_name + " " + self.product.colour.name; }
        if (self.product.brand != null) { self.product.extra_name = self.product.extra_name + " " + self.product.brand.name; }
        if (self.product.country != null) { self.product.extra_name = self.product.extra_name + " " + self.product.country.name; }
        if (self.product.model != null) { self.product.extra_name = self.product.extra_name + " " + self.product.model.name; }
        if (self.product.quality != "") { self.product.extra_name = self.product.extra_name + " " + self.product.quality; }
      }
    }
  };
</script>

<style scoped>
/* SAHIFA */
.g-page {
  padding: 20px;
  background: #f4f7f9;
  height: calc(100vh - 56px);
  overflow-y: auto;
}

.g-page::-webkit-scrollbar {
  width: 8px;
}

.g-page::-webkit-scrollbar-track {
  background: transparent;
}

.g-page::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.g-page::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-weight: 800;
  font-size: 22px;
  color: #2c3e50;
  margin: 0;
}

.page-title-sub {
  font-weight: 400;
  font-size: 16px;
  color: #94a3b8;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mb-4 { margin-bottom: 20px; }

/* TUGMALAR */
.btn-save {
  background: #a142f4;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  cursor: pointer;
}

.btn-save:hover {
  background: #8e39d9;
  transform: translateY(-1px);
}

.btn-save sup, .btn-cancel sup {
  font-weight: 400;
  opacity: 0.7;
}

.btn-cancel {
  background: white;
  border: 1px solid #dcdde1;
  color: #7f8c8d;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

/* MODERN CARD */
.modern-card {
  background: white;
  border-radius: 24px;
  padding: 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f2f6;
}

.section-divider-h {
  border-top: 1px solid #f1f2f6;
  margin: 20px 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: #2c3e50;
  font-weight: 700;
  font-size: 15px;
}

.section-header svg {
  color: #a142f4;
}

/* FORM UNITS */
.form-unit {
  margin-bottom: 16px;
}

.form-unit label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 10px;
  padding: 10px 12px;
  color: #2c3e50;
  font-weight: 600;
  font-size: 13px;
  transition: 0.3s;
}

.form-input:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

.form-input.readonly {
  background: #f1f5f9;
  color: #64748b;
}

.checkbox-unit {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.modern-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #a142f4;
  cursor: pointer;
  margin-top: 8px;
}

/* V-SELECT */
::v-deep .modern-vselect .vs__dropdown-toggle {
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 10px;
  padding: 4px;
  min-height: 38px;
  height: auto;
  overflow: visible;
}

::v-deep .modern-vselect.vs--open .vs__dropdown-toggle {
  background: white;
  border-color: #a142f4;
}

::v-deep .modern-vselect .vs__selected-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-width: 0;
  height: auto;
  overflow: visible !important;
}

::v-deep .modern-vselect .vs__selected {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  position: relative !important;
  margin: 2px 0 !important;
  padding: 4px 8px;
  overflow: hidden;
  border: 1px solid #c4b5fd;
  border-radius: 6px;
  background: #ede9fe;
  color: #5b21b6;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .modern-vselect .vs__deselect {
  flex-shrink: 0;
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #7c3aed;
  font-size: 15px;
  line-height: 1;
}

::v-deep .modern-vselect .vs__search {
  min-width: 70px;
}

/* SHTRIX KODLAR */
.shtrix-card {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
  overflow: hidden;
  margin-top: 10px;
}

.shtrix-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f1f5f9;
  font-weight: 700;
  font-size: 13px;
  color: #2c3e50;
}

.shtrix-btn {
  background: #a142f4;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 6px;
}

.shtrix-body {
  max-height: 80px;
  overflow-y: auto;
  padding: 8px 14px;
}

.shtrix-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.shtrix-num {
  font-size: 12px;
  font-weight: 700;
  color: #94a3b8;
  min-width: 20px;
}

/* FOTO */
.photo-card {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
  padding: 15px;
}

.photo-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.photo-input {
  font-size: 12px;
}

.photo-remove {
  background: none;
  border: none;
  cursor: pointer;
}

.photo-preview {
  text-align: center;
}

.photo-preview img {
  max-height: 200px;
  width: auto;
  border-radius: 10px;
}

.photo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;
  color: #cbd5e1;
  gap: 8px;
}

/* NARX CARD */
.price-card {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
  padding: 15px;
}

/* MINI JADVALLAR (Partiya, Sklad) */
.mini-table-wrapper {
  max-height: 180px;
  overflow-y: auto;
  border-radius: 10px;
  border: 1px solid #f1f2f6;
}

.mini-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.mini-table thead th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  padding: 10px 8px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f2f6;
}

.mini-table tbody td {
  padding: 8px;
  border-bottom: 1px solid #f8fafc;
  color: #334155;
}

.mini-table tbody tr:hover {
  background: #faf8ff;
}

.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.table-input {
  width: 100%;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  text-align: right;
}

.table-input:focus {
  border-color: #a142f4;
  outline: none;
}

/* PLUSS BUTTON (v-select ichida) */
.pluss {
  background: #a142f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  cursor: pointer;
  font-weight: 700;
}

.modallist {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .modern-card {
    padding: 15px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}
</style>
